<template>
	<div class="c-item-title-wrap">
		<span class="c-item-title-v">{{ title }}</span>
		<div v-if="more" class="c-item-title-r" @click="handleMore">
			<span class="c-item-title-span">查看更多</span>
			<c-svg-icons name="icon_jiantou" class="c-item-title-svg" />
		</div>
	</div>
</template>

<script setup>
import { debounce } from '@/utils/api';

defineProps({
	title: {
		type: String
	},
	more: {
		type: Boolean,
		default: false
	}
});
const emits = defineEmits(['onMore']);
const handleMore = debounce(
	() => {
		emits('onMore');
	},
	300,
	true
);
</script>

<style lang="less" scoped>
.c-item-title-wrap {
	display: flex;
	justify-content: space-between;
	align-items: center;

	.c-item-title-v {
		color: #1d2129;
		font-family: 'SourceHanSansCN-Medium';
		font-size: 1.8rem;
		font-style: normal;
		font-weight: 500;

		&::after {
			content: '';
			display: block;
			margin-top: 10px;
			width: 51px;
			height: 4px;
			background: #21519d;
			position: relative;
			left:50%;
			transform: translate(-50%);
		}
	}
	.c-item-title-r {
		cursor: pointer;

		.c-item-title-span {
			color: #4e5969;
			font-family: 'SourceHanSansCN-Normal';
			font-size: 14px;
			font-style: normal;
			font-weight: 400;
			line-height: 16px; /* 114.286% */
		}
		.c-item-title-svg {
			color: #4e5969;
			font-size: 16px;
		}
	}
}
</style>
